/**
 * The address an erasure is asked at (chat spec §10).
 *
 * A COMMITTED constant and not a served text, deliberately: §10 makes handing
 * the guest a way to ask for an erasure an obligation of the consent, so this
 * string must not be able to arrive empty. A configurable contact that is unset
 * renders a promise with nothing behind it, on the one screen where the promise
 * is the only thing she leaves with.
 *
 * It lives in `lib/` rather than beside one of the two screens that show it -
 * S6 and S8 - because importing it from the other would drag a screen's whole
 * module, react-query included, into a screen that fetches nothing.
 */
export const CHAT_CONTACT_EMAIL = 'contact@patrickmathieu.net';
